import { state } from "./state";
export class CountryDetail {
  CountryName: string;
  CountryCode: string;
  CountryCurrencyCode: string;
  CountryDialingCode: string;
  CountryState: Array<state>;
  DeliveryMethods: Array<number>;
  isOrigin: boolean;
  isDestination: boolean;
  PhoneNumberLength: number;

  constructor(
    cCode: string,
    cName: string,
    cCurrencyCode: any,
    cDialingCode: string,
    cState?: Array<state>,
    CDeliveryMethods?: Array<number>,
    IsOrigin: boolean = false,
    IsDestination: boolean = false,
    PhoneNumberLength: number = 10
  ) {
    this.CountryName = cName;
    this.CountryCode = cCode;
    this.CountryCurrencyCode = cCurrencyCode;
    this.CountryDialingCode = cDialingCode;
    this.CountryState = cState;
    this.DeliveryMethods = CDeliveryMethods;
    this.isOrigin = IsOrigin;
    this.isDestination = IsDestination;
    this.PhoneNumberLength = PhoneNumberLength;
  }
}

export interface CountryName {
  Language: string;
  Name: string;
}

export interface CurrencyName {
  Language: string;
  Name: string;
}

export interface Currency {
  CurrencyCode: string;
  CurrencyNames: CurrencyName[];
  Default: boolean;
  RoundingPlaces: number;
  Unicode: string;
}

export interface State {
  Cities: string[];
  StateCode: string;
  StateName: string;
}

export interface Country {
  CountryCode: string;
  CountryNames: CountryName[];
  Currencies: Currency[];
  CustomerCareNumber?: any;
  DeliveryMethods: string[];
  DialingCode: string;
  IsDestination: boolean;
  IsOrigin: boolean;
  PhoneNumberLength: number;
  SortOrder: number;
  states: State[];
}

export interface RootObject {
  StatusCode: number;
  StatusMessage: string;
  Countries: Country[];
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/countrylist/countryinformation.ts